export default {

  loadYears(state,params){
    var ind= state.years.findIndex(x=>x.modelId==params.modelId)
    if(ind!=-1&&ind!=undefined){
      state.years[ind].data=params.data;
    }
    else{
      state.years.push(params);
    }
  },

  //заполнить данные марок машин
  loadMarks(state, data){
    state.carMarks=data;
  },

  //заполнить данные по моделям
  loadModels(state, params){
    var ind= state.carModels.findIndex(x=>x.markId==params.markId)
    if(ind!=-1&&ind!=undefined){
      state.carModels[ind].data=params.data;
    }
    else{
      state.carModels.push(params);
    }
  },

  //обновить марку
  editMark(state, editdata){
    var ind= state.carMarks.findIndex(x=>x.id==editdata.id)
    if(ind!=-1&&ind!=undefined){
      state.carMarks.splice(ind,1,editdata);
    }
  },

  //добавить марку
  addMark(state, newdata){
    state.carMarks.push(newdata)
  },

  //удалить марку
  deleteMark(state, markId){
    var ind= state.carMarks.findIndex(x=>x.id==markId)
    if(ind!=-1&&ind!=undefined){
      state.carMarks.splice(ind,1);
    }
  },

  //обновить модель
  editModel(state, editdata){
    var ind= state.carModels.findIndex(x=>x.markId==editdata.carMarkId)
    if(ind!=-1&&ind!=undefined){
      var modelInd= state.carModels[ind].data.findIndex(x=>x.id==editdata.id)
      if(modelInd!=-1)
        state.carModels[ind].data.splice(modelInd,1,editdata);
    }
  },

  //добавить модель
  addModel(state, newdata) {
    var ind = state.carModels.findIndex(x => x.markId == newdata.carMarkId)
    if (ind != -1 && ind != undefined)
      state.carModels[ind].data.push(newdata)
  },

  //удалить модель
  deleteModel(state, params){
    var ind= state.carModels.findIndex(x=>x.markId==params.markId)
    if(ind!=-1&&ind!=undefined){
      var modelInd= state.carModels[ind].data.findIndex(x=>x.id==params.modelId)
      if(modelInd!=-1)
        state.carModels[ind].data.splice(modelInd,1,);
    }
  },
}
